"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const injector_1 = require("./injector");
const base_1 = require("../base");
const tupleSchemaComponent = (0, injector_1.createTupleSchemaComponent)(() => base_1.Field);
exports.default = tupleSchemaComponent;
